export const initHeader = () => {
  initNavToggle()
  initSubMenus()
  initTinyHeader()
}

// In the open mobile menu, tapping a parent item folds its sub-menu out instead of navigating
const initSubMenus = () => {
  document.querySelectorAll('.header__nav .menu-item-has-children').forEach(item => {
    const link = item.querySelector(':scope > a')
    const toggle = document.createElement('button')
    toggle.type = 'button'
    toggle.className = 'sub-toggle'
    toggle.setAttribute('aria-label', `Show ${link.textContent.trim()} pages`)
    toggle.setAttribute('aria-expanded', 'false')
    link.after(toggle)

    const onToggle = e => {
      if (!document.body.classList.contains('nav-open')) return
      e.preventDefault()
      e.stopPropagation()
      const open = item.classList.toggle('is-open')
      toggle.setAttribute('aria-expanded', open)
    }

    link.addEventListener('click', onToggle)
    toggle.addEventListener('click', onToggle)
  })
}

const initNavToggle = () => {
  const menuButton = document.querySelector('.js-nav-toggle')
  menuButton.addEventListener('click', () => {
    const isOpen = menuButton.classList.toggle('open')
    if (isOpen) {
      openNav()
    } else {
      closeNav()
    }
  })
}

const openNav = () => {
  const body = document.querySelector('body')
  body.classList.add('nav-open')
}

export const closeNav = () => {
  const body = document.querySelector('body')
  body.classList.remove('nav-open')
  document.querySelector('.nav-toggle').classList.remove('open')
  document.querySelectorAll('.header__nav .menu-item-has-children.is-open').forEach(item => {
    item.classList.remove('is-open')
    item.querySelector('.sub-toggle').setAttribute('aria-expanded', 'false')
  })
}

const initTinyHeader = () => {
  const header = document.getElementsByTagName('header')[0]

  window.onscroll = function(ev) {
    if (window.scrollY > 100) {
      header.classList.add('tiny-header')
    } else {
      header.classList.remove('tiny-header')
    }
  }
}
